@import './media.css';

.root {
  display: flex;
  align-items: center;
  margin-inline: auto;

  @media (width >= v-sm) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.coverArt {
  width: 3rem;
  height: 3rem;
}

.info {
  flex-grow: 1;
  display: grid;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  padding: 0.25rem 0.5rem;
  overflow: hidden;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.skeletonLine1 {
  margin-top: 0;
  width: 5rem;
}

.skeletonLine2 {
  margin-bottom: 0px;
  width: 8rem;
}

.name,
.artistAndAlbum {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name {
  grid-column: 1 / -1;
}

.artistAndAlbum {
  color: hsl(var(--muted-foreground));
}

.starButton {
  padding: 0.75rem;
}

.dropdownMenuButton {
  padding: 0.75rem;
}
